import { useQuery, UseQueryOptions } from "react-query";
import { getLegal } from "../services/legal.service";
import { IRequest } from "../interfaces/authentication.interface";
import { useQueryClient } from 'react-query';

export function useGetLegal<T extends any = IRequest<string>>(
    locale: string,
    options?: UseQueryOptions<any, unknown, T>
) {

    const cache = useQueryClient().getQueryData(["legal", locale]);

    return useQuery({
        queryKey: ["legal", locale],
        queryFn: () => cache ? cache : getLegal(locale),
        retry: 1,
        refetchOnWindowFocus: false,
        staleTime: 15 * 60 * 1000,
        ...options
    });
}
